import * as React from 'react';
export const taxjarSvg = React.forwardRef(function taxjarSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.5 15.442C10.5 14.09 11.744 13 13.259 13c1.526 0 2.759 1.09 2.759 2.442 0 1.351-1.245 2.442-2.76 2.442-1.525 0-2.758-1.09-2.758-2.442Zm1.526 0c0 .604.552 1.09 1.233 1.09.68 0 1.232-.486 1.232-1.09 0-.605-.551-1.09-1.232-1.09-.681 0-1.233.485-1.233 1.09Zm3.956 6.116c0-1.351 1.233-2.442 2.76-2.442 1.525 0 2.758 1.09 2.758 2.442S20.256 24 18.74 24c-1.525 0-2.758-1.09-2.758-2.442Zm1.515 0c0 .605.552 1.103 1.232 1.09.68 0 1.233-.485 1.233-1.09 0-.604-.552-1.102-1.233-1.102-.68 0-1.232.498-1.232 1.102Zm6.925-9.411c.01 3.874.176 7.795-.01 11.669-.1 2.113-2.843 3.51-4.66 3.827-3.58.634-6.543.47-9.815-.857-.782-.317-.088-1.538.716-1.15 2.952 1.408 6.686 1.549 9.77.398.882-.328 2.138-.939 2.457-1.878.22-.646.11-1.409.11-2.078v-8.464c-4.725 3.863-9.462 7.713-14.187 11.575-.463.376-1.223.141-1.223-.47v-8.686c0-1.35-.374-3.405.496-4.579.352-.47.793-.833 1.289-1.103-.353-.329-.551-.704-.551-1.127V6.688C8.814 4.845 12.537 4 15.996 4c3.458 0 7.18.845 7.18 2.688v2.548c0 1.843-3.722 2.688-7.18 2.688-1.796 0-3.68-.223-5.056-.704-.033 0-.055.011-.077.011.297-.035-.287.07-.364.094-.275.094-.584.212-.793.4-.64.563-.694 1.208-.694 1.983v9.544c4.726-3.862 9.462-7.712 14.188-11.575.462-.375 1.222-.14 1.222.47Zm-8.415-6.809c-3.78 0-5.761.998-5.761 1.35 0 .34 1.982 1.35 5.76 1.35 3.779 0 5.762-.998 5.762-1.35 0-.34-1.983-1.35-5.761-1.35Zm-5.761 3.04v.834c0 .34 1.982 1.35 5.76 1.35 3.779 0 5.762-.998 5.762-1.35V8.38c-1.4.68-3.635.998-5.761.998-2.137 0-4.362-.317-5.761-.998v-.002Z',
      fill: '#3FAE2A',
    }),
  );
});
taxjarSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var taxjar = {
  category: 'brand',
  colorable: false,
  name: 'taxjar',
  svg: taxjarSvg,
};
